import { RightColumn } from "../components/RightColumn"

/**
 * Component for managing radiograph reports in the right column of the application.
 * This is a wrapper around the unified RightColumn component.
 *
 * @param {Object} props - Component props
 * @returns {JSX.Element} The RightColumnRadiograph component
 */
export const RightColumnRadiograph = (props) => {
  return <RightColumn {...props} reportType="radiograph" />
}

export default RightColumnRadiograph
